/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Study_Field_PlaceholderInputs */

const en_company_profile_study_field_placeholder = /** @type {(inputs: Company_Profile_Study_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Computer Science, Business Informatics`)
};

const de_company_profile_study_field_placeholder = /** @type {(inputs: Company_Profile_Study_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Informatik, Wirtschaftsinformatik`)
};

/**
* | output |
* | --- |
* | "e.g. Computer Science, Business Informatics" |
*
* @param {Company_Profile_Study_Field_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_study_field_placeholder = /** @type {((inputs?: Company_Profile_Study_Field_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Study_Field_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_study_field_placeholder(inputs)
	return en_company_profile_study_field_placeholder(inputs)
});